export function normalizeHiddenSectionIds(ids) {
  const seen = new Set()
  const result = []
  ;(Array.isArray(ids) ? ids : []).forEach((id) => {
    const value = id == null ? '' : String(id).trim()
    if (!value || seen.has(value)) return
    seen.add(value)
    result.push(value)
  })
  return result
}

export function sameHiddenSectionIds(left, right) {
  const a = normalizeHiddenSectionIds(left)
  const b = new Set(normalizeHiddenSectionIds(right))
  return a.length === b.size && a.every((id) => b.has(id))
}

export function toggleHiddenSectionId(ids, sectionId) {
  const id = String(sectionId ?? '').trim()
  const current = normalizeHiddenSectionIds(ids)
  if (!id) return current
  return current.includes(id)
    ? current.filter((value) => value !== id)
    : [...current, id]
}
